
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class TestAudioControl extends Vue {

	@Prop() label?: string

	/// <translate>
	/// Test Audio
	/// </translate>

}
